
import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  name: "bs-form-group"
})
export default class BsFormGroupComponent extends Vue {
 
}
